import PublishedModelTableTooltip from "./PublishedModelTableTooltip";
import React from "react";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Drawer from "@mui/material/Drawer";
import DrawerHeader from "../requests/shared/helpers/DrawerHeader";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import ButtonOutlined from "../requests/shared/helpers/ButtonOutlined";
import DrawerFooterContainerLarge from "../requests/shared/helpers/DrawerFooterContainerLarge";
import ButtonDelete from "../requests/shared/helpers/ButtonDelete";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import LaborDriverLocationValues from "./LaborDriverLocationValues";

function LaborDriversFlagsTable(props) {
  const default_data = {
    default: false,
    name: "",
    store_labor_program_flags: [],
    uuid: null,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFormAttempted(false);
  };
  const [modalData, setModalData] = React.useState(default_data);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [expandedFlagUuid, setExpandedFlagUuid] = React.useState(null);
  const [formAttempted, setFormAttempted] = React.useState(false);

  const trimmedName = String(modalData.name || "").trim();
  const nameIsValid = trimmedName.length > 0 && trimmedName.length <= 128;

  const toggleExpandedFlag = (flagUuid) => {
    setExpandedFlagUuid((current) =>
      String(current) === String(flagUuid) ? null : flagUuid
    );
  };

  const openCompanyEditor = (flag) => {
    setModalData(flag);
    setModalEdit(true);
    handleOpen();
  };

  function handleChange(event) {
    const { name, value } = event.target;
    setModalData((prevModalData) => ({
      ...prevModalData,
      [name]: value,
    }));
  }

  async function handleSubmit() {
    setFormAttempted(true);
    if (!nameIsValid) return;
    await props.post_labor_program_flag_company(
      modalData.uuid ? modalData.uuid : null,
      modalData.default,
      trimmedName
    );
    handleClose();
  }

  // console.log("MODAL DATA", modalData.default)

  // console.log("FLAGS", props.laborProgramFlags)

  return (
    <>
      <div className="px-6 pb-6 pt-7 sm:px-4">
        <div className="flex items-start justify-between gap-6 md:flex-col md:items-stretch">
          <div className="min-w-0">
            <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <h3 className="text-xl font-semibold text-slate-900">Flags</h3>
              <span className="text-sm text-slate-500">
                {props.laborProgramFlags?.length || 0} configured
              </span>
            </div>
            <p className="mt-1 max-w-3xl text-sm leading-6 text-slate-500">
              Define true or false company defaults and review the locations
              that use a different value.
            </p>
          </div>
          {!props.readOnly ? (
            <button
              type="button"
              className="inline-flex h-10 shrink-0 items-center rounded-lg bg-violet-700 px-4 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-violet-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-600 focus-visible:ring-offset-2"
              onClick={() => {
                setModalData(default_data);
                setModalEdit(false);
                setFormAttempted(false);
                handleOpen();
              }}
            >
              <AddIcon className="mr-1.5" sx={{ fontSize: 19 }} />
              Add flag
            </button>
          ) : null}
        </div>
        <div className="mt-5 overflow-hidden rounded-xl border border-slate-200 bg-white">
          <div className="overflow-x-auto">
                <PublishedModelTableTooltip readOnly={props.readOnly}>
                <table className="min-w-[680px] w-full table-fixed">
                  <thead className="border-b border-slate-200 bg-slate-50">
                    <tr>
                      <th
                        scope="col"
                        className="w-[38%] px-5 py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="w-[24%] px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500"
                      >
                        Company default
                      </th>
                      <th scope="col" className="w-[30%] px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                        Location values
                      </th>
                      <th scope="col" className="w-[8%] px-4 py-3">
                        <span className="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200">
                    {props.laborProgramFlags?.map((flag) => {
                      const locationValues =
                        props.laborProgramFlagsStoreOverrides?.find(
                          (item) => String(item.uuid) === String(flag.uuid)
                        ) || null;
                      const isExpanded =
                        String(expandedFlagUuid) === String(flag.uuid);
                      const overrideCount =
                        locationValues?.all_stores_with_labor_program_flags?.filter(
                          (storeValue) => storeValue.is_override
                        ).length || 0;
                      const locationValuesId = `flag-${flag.uuid}-locations`;

                      return (
                      <React.Fragment key={flag.uuid}>
                      <tr className="group transition-colors hover:bg-violet-50/50">
                        <td className="px-5 py-4 text-sm">
                          <p className="truncate font-semibold text-slate-900" title={flag.name}>{flag.name}</p>
                        </td>
                        <td className="px-4 py-4 text-sm">
                          <span
                            className={`${
                              flag.default
                                ? "bg-emerald-50 text-emerald-700"
                                : "bg-rose-50 text-rose-700"
                            } inline-flex rounded-md px-2.5 py-1 font-semibold`}
                          >
                            {flag.default ? "True" : "False"}
                          </span>
                        </td>
                        <td className="px-4 py-4 text-sm">
                            <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${overrideCount > 0 ? "bg-violet-50 text-violet-700" : "bg-slate-100 text-slate-600"}`}>
                              {overrideCount} {overrideCount === 1 ? "override" : "overrides"}
                            </span>
                        </td>
                        <td className="px-4 py-4 text-right text-sm font-medium">
                          <div className="flex items-center justify-end gap-1 text-slate-500">
                            {!props.readOnly ? (
                              <Tooltip title="Edit company default">
                                <button
                                  type="button"
                                  aria-label={`Edit ${flag.name} company default`}
                                  className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-slate-500 hover:bg-white hover:text-violet-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-600"
                                  onClick={() => openCompanyEditor(flag)}
                                >
                                  <EditOutlinedIcon fontSize="small" />
                                </button>
                              </Tooltip>
                            ) : null}
                            <Tooltip title={isExpanded ? "Hide location values" : "Show location values"}>
                              <button
                                type="button"
                                aria-label={`${isExpanded ? "Hide" : "Show"} location values for ${flag.name}`}
                                aria-expanded={isExpanded}
                                aria-controls={locationValuesId}
                                className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-slate-500 hover:bg-white hover:text-violet-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-600"
                                onClick={() => toggleExpandedFlag(flag.uuid)}
                              >
                                <ChevronRightIcon
                                  className={`transition-transform ${
                                    isExpanded ? "rotate-90" : ""
                                  }`}
                                />
                              </button>
                            </Tooltip>
                          </div>
                        </td>
                      </tr>
                      {isExpanded ? (
                        <tr id={locationValuesId} className="bg-slate-50">
                          <td colSpan={4} className="p-0">
                            <LaborDriverLocationValues
                              type="flag"
                              item={locationValues}
                              readOnly={props.readOnly}
                              onSave={props.post_labor_program_flag_store}
                            />
                          </td>
                        </tr>
                      ) : null}
                      </React.Fragment>
                      );
                    })}
                    {!props.laborProgramFlags?.length ? (
                      <tr>
                        <td colSpan={4} className="px-6 py-12 text-center text-sm text-slate-500">
                          No flags yet. Add one to use a true or false company
                          or location condition in labor standards.
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
                </PublishedModelTableTooltip>
          </div>
        </div>
      </div>
      <Drawer open={open} anchor="right" onClose={handleClose}>
        <div className="w-[450px] h-full">
          <div className="max-h-screen overflow-auto">
            <DrawerHeader
              title={modalEdit ? "Edit Flag" : "Add Flag"}
              onClose={handleClose}
            />
            <div className="w-full px-6">
              <div className="mt-5">
                <p className="text-sm text-slate-500">Name</p>
                <div className="mt-1">
                  <TextField
                    placeholder="Driver name"
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="name"
                    value={modalData.name}
                    onChange={handleChange}
                    onBlur={() => setFormAttempted(true)}
                    error={formAttempted && !nameIsValid}
                    helperText={
                      formAttempted && !nameIsValid
                        ? "Enter a name up to 128 characters."
                        : ""
                    }
                    inputProps={{ maxLength: 128 }}
                    InputProps={{
                      sx: {
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "5px",
                        height: "45px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6d28d9",
                        },
                      },
                    }}
                  />
                </div>
              </div>
              <div className="mt-5">
                <p className="text-sm text-slate-500">Default value</p>
                <div className="mt-1">
                  <Select
                    fullWidth
                    value={modalData.default}
                    name="default"
                    onChange={handleChange}
                    size="small"
                    sx={{
                      borderRadius: "8px",
                      paddingY: "1px",
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6d28d9",
                      },
                      height: "45px",
                      backgroundColor: "white",
                    }}
                  >
                    <MenuItem value={true}>True</MenuItem>
                    <MenuItem value={false}>False</MenuItem>
                  </Select>
                </div>
              </div>
            </div>
            <div className="h-[200px]"></div>
          </div>
          <div>
            <DrawerFooterContainerLarge>
              <div className="w-full">
                <LoadingButton
                  variant="contained"
                  // loading={savingLoading}
                  loadingPosition="end"
                  endIcon={<SaveIcon />}
                  disabled={!nameIsValid}
                  onClick={() => handleSubmit()}
                  sx={{
                    width: "100%",
                    textTransform: "none",
                    borderRadius: "12px",
                    paddingY: "14px",
                    backgroundColor: "#6d28d9",
                    "&:hover": {
                      backgroundColor: "#5b21b6",
                    },
                    fontSize: "16px",
                  }}
                >
                  {modalEdit ? "Save Changes" : "Save Flag"}
                </LoadingButton>
              </div>
              <div className="w-full mt-3">
                {modalEdit ? (
                  <ButtonDelete
                    text="Delete"
                    onClick={() => {
                      props.delete_labor_program_flag_company(modalData.uuid);
                      handleClose();
                    }}
                  />
                ) : (
                  <ButtonOutlined text="Cancel" onClick={() => handleClose()} />
                )}
              </div>
            </DrawerFooterContainerLarge>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default LaborDriversFlagsTable;
